export default __webpack_public_path__ + "static/media/mysql.8ca52c25.png";